"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const redux_1 = require("redux");
const utils_1 = require("../utils");
const types = require("./types");
// eslint-disable-next-line @rushstack/typedef-var
const isAuthenticated = utils_1.createReducer(false)({
    [types.LOGOUT_SUCCESS]: () => false,
    [types.LOGIN_SUCCESS]: () => true
});
// eslint-disable-next-line @rushstack/typedef-var
const jwt = utils_1.createReducer(null)({
    [types.LOGIN_REQUEST]: (state, action) => action.jwt,
    [types.LOGIN_FAILURE]: () => null,
    [types.LOGOUT_SUCCESS]: () => null
});
// eslint-disable-next-line @rushstack/typedef-var
const errorMessage = utils_1.createErrorMessageReducer('session');
// eslint-disable-next-line @rushstack/typedef-var
const isProcessing = utils_1.createIsProcessingReducer('session');
exports.default = redux_1.combineReducers({
    errorMessage,
    isAuthenticated,
    isProcessing,
    jwt
});
//# sourceMappingURL=reducers.js.map